module.exports = __webpack_public_path__ + "static/new-core-alternative-234fd718115e4e7f9b1b4b293899cb61.webp";